import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useParams } from 'next/navigation';
import Button from '../common/Button';
const NoSpaceFound = () => {
  const $ = _c(7);
  const params = useParams();
  const spaceSlug = params?.spaceSlug;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="size-32 rounded-full bg-background-light" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] !== spaceSlug) {
    t1 = !spaceSlug ? <p className="text-2xl font-semibold text-textPrimary">Website under Maintenance</p> : <><p className="text-2xl font-semibold text-textPrimary">Sorry, there aren't any Spaces on Factiii with that name.</p><p className="text-center text-textSecondary/70">This Space may have been deleted or banned, or the Space name is incorrect.</p></>;
    t2 = !spaceSlug && <div className="flex space-x-4"><Link href="/spaces"><Button text="Create Space" classNames="px-6" /></Link><Link href="/"><Button text="Go Home" classNames="px-10" borderTransparent={false} variant="SECONDARY" /></Link></div>;
    $[1] = spaceSlug;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col items-center gap-y-4 p-6">{t0}{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default NoSpaceFound;